import { axios } from '@/utils/request'

const api = {
  storageAccessory: '/stock/storageAccessory'
}

const api2 = {
  storageAccessory: '/stock/selectutils'
}

const api3 = {
  accessory: '/stock/selectutils'
}
// 导出
export function storageExport (parameter) {
  return axios({
    url: api.storageAccessory + '/storageExport',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }

  })
}

export function selectenterprise (parameter) {
  return axios({
    url: api3.accessory + '/selectsupplier',
    method: 'get',
    params: parameter,

  })
}

export function selectStorageAccessory (parameter) {
  return axios({
    url: api3.accessory + '/selectOutStorageAccessory',
    method: 'get',
    params: parameter,

  })
}

export function getStorageAccessoryList (parameter) {
  return axios({
    url: api.storageAccessory + '/accessorystoragelist',
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getoneaccessorystorage (parameter) {
  return axios({
    url: api.storageAccessory + '/getoneaccessorystorage',
    method: 'post',
    data: parameter,

  })
}

export function manualoutstorage (parameter) {
  return axios({
    url: api.storageAccessory + '/manualoutstorage',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function manualinstorage (parameter) {
  return axios({
    url: api.storageAccessory + '/manualinstorage',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 删除
export function delStorageAccessory (parameter) {
  return axios({
    url: api.storageAccessory + '/delStorageAccessory\n',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function forbiddenaccessorystorage (parameter) {
  return axios({
    url: api.storageAccessory + '/forbiddenaccessorystorage',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function selectaccessory (parameter) {
  return axios({
    url: api2.storageAccessory + '/selectaccessory',
    method: 'get',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function selectstore (parameter) {
  return axios({
    url: api2.storageAccessory + '/selectstore',
    method: 'get',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}




export const storageAccessoryExport = api.storageAccessory + '/export'
